import angular from 'angular';
import colorSelector from './colorSelector';

export default angular
  .module('components.colorSelector', [])
  .component('colorSelector', colorSelector).name;
